.buttonsContainer {
  display: flex;
  align-items: center;
  margin-top: 12px;
  column-gap: 15px;
  justify-content: space-between;
  width: 100%;

  &.topBorder {
    margin-top: 0;
    padding-top: 12px;
    @include themify($themes) {
      border-top: 1px solid themed("neutral-secondary");
    }
  }

  &.centerButton {
    justify-content: center;
  }

  .submit {
    margin-top: 0;
    border-radius: 50rem;
    color: #142F43;
    font-size: 14px;

    &:only-child {
      margin: 0 auto;
    }
  }

  .submitContainer {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .cancel {
    display: flex;
    justify-content: center;

    a {
      padding: 10px 25px;
      border-radius: 50rem;
      background: #D8DDE3;
      color: #142F43;
      font-size: 17px;
      font-weight: 700;
      text-decoration: none;
      transition: background .25s ease-out;


      &:hover {
        text-decoration: none;
        background: #89969F;
      }
    }

    &.transparentButton {
      a {
        background: transparent;
        padding: 0;
        font-size: 16px;
        font-weight: 500;

        @include themify($themes) {
          color: themed('font_primary');
        }
      }
    }

  }
}
